import styled from 'styled-components'
import { Box } from '@material-ui/core'

export const Footer = styled(Box)`
  padding: 0.25rem;
  background-color: ${props => props.color? props.color : props.theme.palette.footer.main};

  @media(min-width: 900px) and (min-height: 900px) {
    padding: 0.5rem;
  }
  @media (max-height: 681px) and (min-width: 900px) {
    height: 2.5rem;
    overflow: hidden;
  }

  .middlebutton {
    flex-grow: 1;
    display: flex;
    justify-content: center;
  }

  .endbutton {
    flex-grow: 1;
    display: flex;
    justify-content: flex-end;
  }

  ${ props => props.logos?
  `    
    margin: 0;
    padding: 0;
    height: 10vh;    
    display: flex;
    justify-content: center; 
    align-items: center;
    padding: .5rem;

    @media(min-width: 900px) {
      height: 17.5vh;
    }

    @media(min-width: 1800px) {
      height: 15vh;
    }

    img {
      width: 90%;
      height: 90%;
      object-fit: contain;
    }    
  `
  :
  ``
  }
`